var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_420_12676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.489 2 2 6.489 2 12C2 17.511 6.489 22 12 22C17.511 22 22 17.511 22 12C22 6.489 17.511 2 12 2ZM12 4C16.4301 4 20 7.56988 20 12C20 13.8531 19.3693 15.5506 18.3184 16.9043L7.0957 5.68164C8.44944 4.63074 10.1469 4 12 4ZM5.68164 7.0957L16.9043 18.3184C15.5506 19.3693 13.8531 20 12 20C7.56988 20 4 16.4301 4 12C4 10.1469 4.63074 8.44944 5.68164 7.0957Z",
    fill: "black",
    fillOpacity: 0.54
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_420_12676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotAvailable);
export default __webpack_public_path__ + "static/media/icon-not-available.52e25faf946e8756ff32cb801dc891be.svg";
export { ForwardRef as ReactComponent };